import { WixLineItem } from '../model/cartModel';
import { Payment, PaymentType } from '../model/Payment';

const ADVANCE_PAYMENT_RATE = Number(process.env.REACT_APP_ADVANCE_PAYMENT_RATE || '');
const ADVANCE_PAYMENT_MINIMUM = Number(process.env.REACT_APP_ADVANCE_PAYMENT_MINIMUM || '');

export function calculateTotal(shippingCost: number, items: WixLineItem[]): number {
    if (items) {
        const subtotal: number = items
            .map((item) => {
                return item.lineItemPrice.amount;
            })
            .reduce((sum, item) => sum + parseFloat(item), 0);
        return subtotal + (shippingCost || 0);
    }
    return 0;
}

export function calculateAdvancePayment(total: number): number {
    const advancePaymentTotal = total * ADVANCE_PAYMENT_RATE;

    if (advancePaymentTotal < ADVANCE_PAYMENT_MINIMUM) {
        return ADVANCE_PAYMENT_MINIMUM;
    }

    return advancePaymentTotal;
}

export function calculatePayment(
    wixShippingCost: number,
    items: WixLineItem[],
    novaPostShippingCost: number,
    paymentType: PaymentType,
): Payment {
    const total = calculateTotal(wixShippingCost, items) + novaPostShippingCost;
    const prepayment = calculateAdvancePayment(total);
    const COD = total - prepayment;

    return {
        total,
        prepayment,
        COD,
        paymentType,
    };
}
